(function () {
  var CUTOFF_HOUR = 21;        /* Werkelijke verwerkingstijd, voor de datumberekening */
    var CUTOFF_MINUTE = 30;
    var DISPLAY_CUTOFF_HOUR = 19; /* De tijd die je de klant belooft, voor de aftelling */
  var SATURDAY_DELIVERY = true;  /* PostNL bezorgt op zaterdag */
  var USE_RELATIVE = false;      /* Op true voor "morgen" / "overmorgen" */
  var TIMER_FROM_HOUR = 18;      /* Vanaf dit uur tellen we af naar de cut-off */

  var HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-04-27',
    '2026-05-14', '2026-05-25', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-04-27',
    '2027-05-06', '2027-05-17', '2027-12-25', '2027-12-26'
  ];

  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MONTHS = ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
                'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  function amsterdamNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });

    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour === 24 ? 0 : +parts.hour,
      minute: +parts.minute,
      second: +parts.second
    };
  }

  function iso(d) { return d.toISOString().slice(0, 10); }
  function isHoliday(d) { return HOLIDAYS.indexOf(iso(d)) !== -1; }

  function isShippingDay(d) {
    var day = d.getUTCDay();
    return day !== 0 && day !== 6 && !isHoliday(d);
  }

  function isDeliveryDay(d) {
    var day = d.getUTCDay();
    if (day === 0) return false;
    if (day === 6) return SATURDAY_DELIVERY && !isHoliday(d);
    return !isHoliday(d);
  }

  function addDays(d, n) {
    var c = new Date(d.getTime());
    c.setUTCDate(c.getUTCDate() + n);
    return c;
  }

  function nextShippingDay(d) {
    var c = addDays(d, 1);
    while (!isShippingDay(c)) c = addDays(c, 1);
    return c;
  }

  function nextDeliveryDay(d) {
    var c = addDays(d, 1);
    while (!isDeliveryDay(c)) c = addDays(c, 1);
    return c;
  }

  function label(delivery, today) {
    if (USE_RELATIVE) {
      var diff = Math.round((delivery - today) / 86400000);
      if (diff === 1) return 'morgen';
      if (diff === 2) return 'overmorgen';
    }
    return DAYS[delivery.getUTCDay()] + ' ' +
           delivery.getUTCDate() + ' ' +
           MONTHS[delivery.getUTCMonth()];
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

 function formatDate(d) {
    var lang = document.documentElement.lang || 'nl';
    try {
      return new Intl.DateTimeFormat(lang, {
        weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
      }).format(d);
    } catch (err) {
      return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
    }
  }

  function render() {
    var els = document.querySelectorAll('[data-delivery-estimate]');
    if (!els.length) return;

    var now = amsterdamNow();
    var today = now.date;

    var nowMins = now.hour * 60 + now.minute;
    var canShipToday = isShippingDay(today) && nowMins < (CUTOFF_HOUR * 60 + CUTOFF_MINUTE);
    var shipDay = canShipToday ? today : nextShippingDay(today);
    var delivery = nextDeliveryDay(shipDay);
    var dateText = formatDate(delivery);

    var urgent = isShippingDay(today) && now.hour >= TIMER_FROM_HOUR && nowMins < DISPLAY_CUTOFF_HOUR * 60;
    var weekend = !isShippingDay(today);
    var timerText = '';

    if (urgent) {
      var left = (DISPLAY_CUTOFF_HOUR * 3600) - (now.hour * 3600 + now.minute * 60 + now.second);
      timerText = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    }

    els.forEach(function (el) {
      var normal = el.querySelector('[data-de-normal]');
      var urgentEl = el.querySelector('[data-de-urgent]');
      var timer = el.querySelector('[data-de-timer]');

      el.querySelectorAll('[data-de-date]').forEach(function (node) {
        if (node.textContent !== dateText) node.textContent = dateText;
      });

      if (timer && timer.textContent !== timerText) timer.textContent = timerText;

    var weekendEl = el.querySelector('[data-de-weekend]');
      if (normal) normal.hidden = urgent || weekend;
      if (urgentEl) urgentEl.hidden = !urgent;
      if (weekendEl) weekendEl.hidden = !weekend;

      el.classList.toggle('is-urgent', urgent);
      el.hidden = false;
    });
  }

  render();
  /* Elke seconde: laat de teller lopen, vangt 19:00 op, en pakt blokken
     op die je thema opnieuw heeft gerenderd bij een variantwissel. */
  setInterval(render, 1000);
  document.addEventListener('cart:refresh', render);
})();
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cd-scroll]');
  if (!btn) return;
  var list = document.querySelector('.complementary-products__product-list--carousel');
  if (!list) return;
  list.scrollBy({ left: btn.dataset.cdScroll === 'next' ? 200 : -200, behavior: 'smooth' });
});